import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-views',
  template: `
    <p>
      transactions works!
    </p>
  `,
  styles: [
  ]
})
export class ViewsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
